
import { computed, defineComponent } from "vue";
import GammaStepper from "@/components/GammaStepper.vue";
import FileSelect from "@/components/modals/BookUploaderModal/FileSelect.vue";
import FileUpload from "@/components/modals/BookUploaderModal/FileUpload.vue";
import FileMetadata from "@/components/modals/BookUploaderModal/FileMetadata.vue";
import DataTagging from "@/components/modals/BookUploaderModal/DataTagging.vue";
import { Step } from "@/types";
import { useBooks } from "@/services";

export default defineComponent({
  name: "BookUploadModal",
  components: {
    GammaStepper,
  },
  data() {
    return {
      stepperItems: [
        {
          component: FileSelect,
          name: "FileSelect",
          canGoNext: () => computed(() => !useBooks().isFileInvalid),
        },
        {
          component: FileMetadata,
          name: "FileMetadata",
          canGoNext: () => computed(() => useBooks().isMetaDataValid),
        },
        {
          component: DataTagging,
          name: "DataTagging",
          canGoNext: () => computed(() => useBooks().isDataTaggingValid),
        },
        {
          component: FileUpload,
          name: "FileUpload",
        },
      ] as Step[],
    };
  },
});
